import { render, staticRenderFns } from "./PurchaseOrderExtraChargeModal.vue?vue&type=template&id=5998a0c4&scoped=true&"
import script from "./PurchaseOrderExtraChargeModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderExtraChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998a0c4",
  null
  
)

export default component.exports